<template>
  <div class="w-full h-full">
    <!-- pdf -->
    <iframe
      :src="`/lib/pdfjs/web/viewer.html?file=${fileUrl}#page=1&zoom=70`"
      id="mainPdfIframe"
      @load="fileLoaded"
      class="w-full h-full"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    fileUrl: {
      type: String,
      defalut: '',
    },
  },
  components: {},
  data() {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    fileLoaded() {
      this.$emit('fileLoaded')
    },
  },
  created() {},
}
</script>
